import React from 'react';
import * as CurrencyUtils from '../../utils/currency';
import * as DateUtils from 'utils/dates';
import { Languages } from '../../config';
import ActionsBlock from './components/datatable/ActionBlock';

const CONFIGURATION = {};

export const allowedActions = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'payment_info_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'MSCON Country',
    id: 'country',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Amount Received',
    id: 'amount_received',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Payment Reference',
    id: 'payment_reference',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Pending'}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Payment Date',
    id: 'payment_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        <React.Fragment>
          {cellValue ? DateUtils.formatDate(cellValue) : 'Pending'}
        </React.Fragment>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Scheme Type',
    id: 'application_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        <React.Fragment>{cellValue}</React.Fragment>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        payment_info_id={data[rowIndex].payment_info_id}
        payment_reference={data[rowIndex].payment_reference}
        payment_date={data[rowIndex].payment_date}
        status={data[rowIndex].status}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Payment Info',
    [Languages.English]: 'Payment Info',
  },
  payment_info_reference: {
    [Languages.Greek]: 'Payment info reference',
    [Languages.English]: 'Payment info reference',
  },
  title: {
    [Languages.Greek]: 'Payment information',
    [Languages.English]: 'Payment information',
  },
  description: {
    [Languages.Greek]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
    [Languages.English]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  payment_reference: {
    [Languages.Greek]: 'Payment Reference',
    [Languages.English]: 'Payment Reference',
  },
  schemeType: {
    [Languages.Greek]: 'Scheme Type',
    [Languages.English]: 'Scheme Type',
  },
  msconCountry: {
    [Languages.Greek]: 'MSCON Country',
    [Languages.English]: 'MSCON Country',
  },
  state: {
    [Languages.Greek]: 'State',
    [Languages.English]: 'State',
  },
};
